import React from 'react';
let stackConsumers = [];
class StackConsumer extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            stackIndex: 0,
        };
        this.update = () => {
            const stackIndex = stackConsumers.indexOf(this.update);
            if (this.state.stackIndex !== stackIndex) {
                this.setState({ stackIndex });
            }
        };
    }
    componentDidMount() {
        stackConsumers.forEach((updateFn) => updateFn());
    }
    componentWillUnmount() {
        if (stackConsumers.indexOf(this.update) !== -1) {
            stackConsumers = stackConsumers.filter((stack) => stack !== this.update);
            stackConsumers.forEach((updateFn) => updateFn());
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isOpen && !this.props.isOpen) {
            stackConsumers = stackConsumers.filter((stack) => stack !== this.update);
            stackConsumers.forEach((updateFn) => updateFn());
        }
    }
    render() {
        if (stackConsumers.indexOf(this.update) === -1) {
            stackConsumers = [this.update, ...stackConsumers];
        }
        return this.props.children(this.state.stackIndex);
    }
}
export default StackConsumer;
//# sourceMappingURL=StackConsumer.js.map